import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["copy"];

  copy({ target }) {
    this.copyTarget.textContent = target.value.trim();
  }
}
